import request from 'utils/request'
import { MCAXS290InitRequest } from 'types/MCAXS290/MCAXS290InitRequest'

export const entryHistoryApi = (param: MCAXS290InitRequest) =>
  request({
    url: "/MCAXS290/init",
    method: 'post',
    data: param,
  })